import React, { useEffect, useState } from "react";
import BottomSheet from "../../components/BottomSheet";
import { useNavigate, useLocation } from "react-router-dom";
import TopHeader from "../../components/TopHeader";
import GoogleLogin from "react-google-login";
import { env } from "../../env";
import useGoogleLogin from "../../hooks/useGoogleLogin";

import { toast } from 'react-hot-toast';
import { useLoginMutation } from "../../services/userApi";
import { Notification } from "../../components/ToastNotification";


const AuthSplashScreen = () => {
  const navigate = useNavigate();
  const { responseGoogle, resFailed } = useGoogleLogin();
  const [showMobileLogin, setShowMobileLogin] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // const [isChecked, setIsChecked] = useState(true);

  const [login, { data: loginData, isLoading, error }] = useLoginMutation();

  const handleGoogleClick = (renderProps) => {
    // if (!isChecked) {
    //   toast.error("Please check the consent box to proceed");
    //   return;
    // }
    renderProps.onClick(); 
  };

  const sponsorID =
    searchParams.get("sponsorId") || searchParams.get("sponsorid");

  const handleGuestLogin = async() => {
    const newObj = {
      username: "__rtesGU32vc__kkss693x",
      password: "__hdfsjd645dnnd__kk434keokldi",
      guestKey: "kj9f__94ijfd899__4k9df9j4"
    };
    
    await login(newObj);
  }

  useEffect(() => {
    console.log(location.search);
  }, [location.search]); // Runs only when the URL query changes

  useEffect(() => {
    const detectCountry = async () => {
      try {
        const response = await fetch(
          `https://ipgeolocation.abstractapi.com/v1/?api_key=cceebbeb66fe43368c307932eaa93b96`
        );
        const data = await response.json();
        setShowMobileLogin(data.country_code === "IN");
      } catch (error) {
        console.error("Error detecting country:", error);
        setShowMobileLogin(false);
      }
    };

    // Check if we have a cached result
    const cachedCountry = localStorage.getItem("userCountry");
    if (cachedCountry) {
      setShowMobileLogin(cachedCountry === "IN");
    } else {
      detectCountry();
    }
  }, []);

  useEffect(() => {
    if (loginData?.message) {
      Notification(loginData?.message, "success");
      localStorage.setItem("tp_Aa_uth_access", loginData?.data.token);
      const userCountry = loginData?.data?.country || "India";
      localStorage.setItem("userCountry", userCountry);
      navigate("/home");
      window.location.reload();


      navigate(0);
    }
    if (error) {
      Notification(error?.data?.message, "error");
    }
  }, [loginData, error, navigate]);

  return (
    <div className="tpu__authSplashScreen__wrapper layoutContainer">
      {/* Header */}
      <TopHeader title="Login/Register" para="Ready to play and earn?" />
      {/* Bottom Sheet */}
      <BottomSheet height="85%">
        <div className="tpu__splashScreen__bottomSheet__content">
          <div className="google__login__btn">
            {/* <button type="button" className="google__btn">
              <img
                src="https://res.cloudinary.com/green-valley-grocery/image/upload/f_auto,q_auto/v1667014540/tp-app-assests/icons/google_pnf6be.png"
                alt="google icon"
              />
              <span>sign in with google</span>
            </button> */}
            <GoogleLogin
              clientId={env.google_client_id}
              buttonText="Sign in with google"
              onSuccess={responseGoogle}
              onFailure={resFailed}
              cookiePolicy={"single_host_origin"}
              className="google__btn"

              render={(renderProps) => (
                <button
                
                  onClick={() => handleGoogleClick(renderProps)}
                  disabled={renderProps.disabled || isLoading}
                  className="google__btn"

                  style={{
                    color:"#575757"
                  }}
                >
                  Sign in with 
                </button>
              )}
            />
          </div>

          <div className="tpu__separator">
            <p className="dashed__separator">Or</p>
            <p className="separator__text">Or</p>
          </div>

          <div className="google__login__btn otherLoginButtons">
            {/* <button
              type="button"
              className="google__btn"
              onClick={() => navigate("/loginWithMobile")}
            >
              <img
                src="https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1714559065/TaskPlanet/computer-icons-mobile-phones-clip-art-telephone-call-phone-number-icon-removebg-preview_gaolbp.webp"
                alt="google icon"
              />
              <span>mobile</span>
            </button> */}
            <button
              type="button"
              className="google__btn"
              // onClick={() => navigate("/loginWithEmail")}
              onClick={() => {
                // if (!isChecked) {
                //   toast.error("Please check the consent box to proceed");
                //   return;
                // }
                

                const path = sponsorID
                  ? `/loginWithEmail?sponsorId=${sponsorID}`
                  : "/loginWithEmail";
                navigate(path);
              }}
              disabled={isLoading}
            >
              <img
                src="https://res.cloudinary.com/djfzcmvmr/image/upload/f_auto,q_auto/v1714558787/TaskPlanet/2250206_se0etj.png"
                alt="google icon"
              />
              <span>email</span>
            </button>
          </div>
          <div className="google__login__btn otherLoginButtons" style={{ marginTop: 6 }}>
            <button
              type="button"
              className="google__btn guest-btn"
              // onClick={() => navigate("/loginWithEmail")}
              onClick={() => {
                // if (!isChecked) {
                //   toast.error("Please check the consent box to proceed");
                //   return;
                // }
                
                handleGuestLogin();
              }}
              disabled={isLoading}
            >
              {/* <img
                src="https://res.cloudinary.com/djfzcmvmr/image/upload/f_auto,q_auto/v1714558787/TaskPlanet/2250206_se0etj.png"
                alt="google icon"
              /> */}
              <span>{isLoading ? "Logging in..." : "Continue as Guest"}</span>
            </button>
          </div>


          <div style={{ marginTop: "14px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <p style={{ fontSize: "11px", color: "#6b7280", textAlign: "center", margin: "0 0 5px 0" }}>
              By continuing, you agree to TaskPlanet's
            </p>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "6px" }}>
              <span
                onClick={() => navigate("/terms-and-conditions")}
                style={{ color: "#3797F0", fontSize: "11px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
              >
                Terms & Conditions
              </span>
              <span style={{ color: "#6b7280", fontSize: "11px" }}>•</span>
              <span
                onClick={() => navigate("/privacy-policy")}
                style={{ color: "#3797F0", fontSize: "11px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
              >
                Privacy Policy
              </span>
              <span style={{ color: "#6b7280", fontSize: "11px" }}>•</span>
              <span
                onClick={() => navigate("/contact-us")}
                style={{ color: "#3797F0", fontSize: "11px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
              >
                Contact Us
              </span>
            </div>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
};

export default AuthSplashScreen;
